// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3vA84","inputDescription":"styles_inputDescription__1kLsd"};